import React from 'react';
import { withTheme } from 'styled-components';

const SearchIcon = ({ width, height, theme }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-ignore-click-outside="sidebar"
    >
      <circle
        cx="11.4141"
        cy="11.0992"
        r="7.66407"
        stroke={
          theme.themeColors.controlBar.rightPanel.icons.searchIcon
            .color
        }
        strokeWidth="2"
        data-ignore-click-outside="sidebar"
      />
      <path
        d="M23.4767 25.8382C23.8463 26.2486 24.4786 26.2818 24.889 25.9122C25.2994 25.5427 25.3325 24.9104 24.963 24.4999L23.4767 25.8382ZM16.2515 17.8138L23.4767 25.8382L24.963 24.4999L17.7378 16.4755L16.2515 17.8138Z"
        fill={
          theme.themeColors.controlBar.rightPanel.icons.searchIcon
            .color
        }
        data-ignore-click-outside="sidebar"
      />
    </svg>
  );
};

export default withTheme(SearchIcon);
